<template>
    <canvas ref="chart"></canvas>
</template>
<script lang="ts">
import LineChart, {ChartDataSet} from '@/components/charts/LineChart';
import {NumberType} from '@/components/charts/numbers';
import {TimeUnit} from 'chart.js';
import {defineComponent, onMounted, PropType, ref} from 'vue';

export default defineComponent({
    props: {
        dataSets: {
            type: Array as PropType<ChartDataSet[]>,
            required: true,
        },
        period: {
            type: String as PropType<TimeUnit>,
            required: true,
        },
        numberType: {
            type: String as PropType<NumberType>,
            required: true,
        },
        axisYTitle: {
            type: String,
            required: true,
        },
        language: {
            type: String,
            required: true,
        },
        currency: {
            type: String,
            required: true,
        },
        legend: {
            type: Boolean,
            default: true,
        },
    },
    setup(props) {
        const chart = ref<HTMLCanvasElement | null>(null);

        let lineChart: LineChart;

        onMounted(() => {
            lineChart = new LineChart(
                chart.value as HTMLCanvasElement,
                props.axisYTitle,
                props.dataSets,
                props.period,
                props.numberType,
                props.language,
                props.currency,
                props.legend,
            );
        });

        return {chart};
    },
});
</script>
